import React from "react";
import { useTranslation } from "react-i18next";

import { InboxIcon } from "../../Icons";
import EmptyState from "../../EmptyState";

export default () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      iconComponent={InboxIcon}
      title={t("grid.empty.title")}
      subtitle={t("grid.empty.subtitle")}
    />
  );
};
